import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Box,
  Button,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import useAlert from "../hooks/useAlert";

import {
  deleteCategoryVaiant,
  getCategoryVaiant,
} from "../redux/actions/categorysActions";
import CategoryVariantAdd from "./UI/reusable-components/CategoryVariantComponents/AddCategoryVariant";

export const CategoryVariant = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState(data);
  const [searchVisible, setSearchVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();

  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);

  const handleSearchToggle = () => {
    setSearchVisible((prev) => !prev);
    setSearchTerm("");
    setFilteredData(data);
  };

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  const handleSearchChange = (event) => {
    const term = event.target.value.toLowerCase();
    setSearchTerm(term);
    const filtered = data.filter((item) =>
      item.name.toLowerCase().includes(term)
    );
    setFilteredData(filtered);
  };

  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const {
    showSuccessAlertCategoryVariantDelete,
    showErrorAlertCategoryVariantDelete,
  } = useAlert();
  const deleteCategoryVariant = async (id) => {
    const confirmDelete = window.confirm(
      "Bu eşleştirmeyi silmek istediğinizden emin misiniz?"
    );

    if (confirmDelete) {
      try {
        const response = await dispatch(deleteCategoryVaiant(id, token));

        if (response.status) {
          showSuccessAlertCategoryVariantDelete();
          dispatch(getCategoryVaiant(authUserId, token));
        }
        return response;
      } catch (error) {
        showErrorAlertCategoryVariantDelete();
        console.error("Error deleting address:", error);
      }
    }
  };

  useEffect(() => {
    if (authUserId) {
      dispatch(getCategoryVaiant(authUserId, token));
    }
  }, []);

  const categoryVariants = useSelector((state) => state?.categoryVariant);

  useEffect(() => {
    setData(categoryVariants?.categoryVariant);
  }, [categoryVariants]);

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Box sx={{ mt: 5 }}>
          <Button
            sx={{ borderRadius: 1, mr: 2 }}
            size="small"
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleOpenModal}
          >
            Ekle
          </Button>
          {/* <Button
                        sx={{ borderRadius: 1 }}
                        size="small"
                        variant="contained"
                        color="primary"
                        startIcon={<SearchIcon />}
                        onClick={handleSearchToggle}
                    >
                        Filtrele
                    </Button> */}
        </Box>
      </Box>

      {searchVisible && (
        <Box sx={{ mb: 3 }}>
          <TextField
            fullWidth
            label="Kategori Ara"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </Box>
      )}

      <TableContainer
        sx={{
          maxHeight: 670,
          maxWidth: "100%",
          p: 3,
          background: "white",
          borderRadius: 1,
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Kategori Adı</TableCell>
              <TableCell>Varyant Adı</TableCell>
              <TableCell>Pazaryeri</TableCell>
              <TableCell>Pazaryeri Varyant adı </TableCell>
              <TableCell sx={{ width: 350 }}>İşlemler</TableCell>
            </TableRow>
          </TableHead>
          {filteredData?.length > 0 ? (
            <TableBody>
              {filteredData.map((item, index) => (
                <TableRow key={index} sx={{ background: "white" }}>
                  <TableCell>{item?.category?.name}</TableCell>
                  <TableCell>{item?.variantName}</TableCell>
                  <TableCell>
                    {item?.marketPlaceName || item?.ecommercePlace?.name}
                  </TableCell>
                  <TableCell>{item.pcVariantName}</TableCell>
                  <TableCell>
                    <Button
                      sx={{
                        borderRadius: 1,
                      }}
                      size="small"
                      variant="contained"
                      color="primary"
                      onClick={() => deleteCategoryVariant(item.id)}
                    >
                      Sil
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell colSpan={4} align="center">
                  Henüz kategori varyantı eşleşirilmedi
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <CategoryVariantAdd open={openModal} handleClose={handleCloseModal} />
    </Box>
  );
};
